import { ChangeEvent } from "react";
import { cancelOrderApi, updateCustomerEmailApi, updateOrderStatusApi } from "../api";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { Order } from "src/shared/services/interfacev2";
import { errorHandling } from "src/shared/utils/errorHandling";

export const updateCustomerEmail = async (
  customerId: string,
  email: string,
  setAgent?: React.Dispatch<React.SetStateAction<boolean>>,
  setGeterror?: React.Dispatch<React.SetStateAction<string>>,
  orderemailmsg?: (order: Order, email: string, received: string, orderId: string, finalAmount: number, remaining: string, handleDone: () => void) => Promise<void>,
  getorder?: Order,
  ordersucess?: Order,
) => {
  if (!customerId) {
    notifyError("Customer ID is missing, cannot update email.");
    return;
  }

  if (!email || !email.trim()) {
    notifyError("No email provided to update.");
    return;
  }

  // ✅ Create the emails array directly (NOT wrapped in an object)
  const emails = [
    {
      email: email.trim(),
      isPrimary: true,
    },
  ];

  try {
    // ✅ Pass the array directly
    await updateCustomerEmailApi(customerId, emails);
    notifySuccess("Email updated successfully!");

    // Optional: Send invoice email after update
    if (orderemailmsg && getorder && ordersucess) {
      orderemailmsg(
        getorder!,
        email.trim(),
        String(ordersucess.paymentHistory?.[0]?.receivedAmount || 0),
        String(ordersucess.orders?.[0]?.orderId ?? ""),
        ordersucess.orders?.[0]?.finalAmount ?? 0,
        String(ordersucess.orders?.[0]?.remainingAmount ?? 0),
        () => {
          if (setAgent) setAgent(false);
        },
      );
    }

    if (setAgent) setAgent(false);
    if (setGeterror) setGeterror("");

    return true;
  } catch (error: any) {
    console.error("Update email error:", error);
    const backendMsg = error?.response?.data?.message;
    if (backendMsg === "Email already exists") {
      notifyError("Email already exists.");
    } else {
      notifyError(backendMsg || "Failed to update email.");
    }
    return false;
  }
};

// ✅ FIXED: Even simpler version for direct use
export const updateCustomerEmailOnly = async (customerId: string, email: string): Promise<boolean> => {
  if (!customerId || !email?.trim()) {
    notifyError("Customer ID or email is missing");
    return false;
  }

  try {
    // ✅ Create the emails array directly (NOT wrapped in an object)
    const emails = [
      {
        email: email.trim(),
        isPrimary: true,
      },
    ];

    // ✅ Pass the array directly
    await updateCustomerEmailApi(customerId, emails);
    notifySuccess("Email updated successfully!");
    return true;
  } catch (error: any) {
    console.error("Update email error:", error);
    const backendMsg = error?.response?.data?.message;
    notifyError(backendMsg || "Failed to update email.");
    return false;
  }
};

export const cancelOrder = async (orderid: string | undefined, cancelData: string, paymentMethod: string | undefined, setmove: Function) => {
  try {
    const now = new Date();
    const localDate = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");
    const localTime = now.toTimeString().split(" ")[0];

    const response = await cancelOrderApi(orderid, cancelData, paymentMethod, localDate, localTime);

    if (response?.status === 200 || response?.data) {
      setmove("Cancelled");
      notifySuccess("Order cancelled successfully");
    } else {
      notifyError("Failed to cancel order");
    }
  } catch (err) {
    console.error("Cancel Order Error:", err);
    errorHandling(err);
    notifyError("An error occurred while cancelling the order");
  }
};

export const handleChange = async (orderid: string | undefined, event: ChangeEvent<HTMLSelectElement>, setmove: Function, getOrdersIn: Function) => {
  try {
    await updateOrderStatusApi(orderid, event.target.value);
    setmove(event.target.value);
    getOrdersIn();
  } catch (err) {
    console.error(err);
  }
};

export const validateAndSetEmail = (value: string, setEmail: React.Dispatch<React.SetStateAction<string>>, setconfirmemail: React.Dispatch<React.SetStateAction<string>>) => {
  const isValidEmail = (value: string): boolean => {
    if (value.trim() === "") return false;
    if (!value.includes("@")) return false;
    const validDomains = [".com", ".in", ".co"];
    const hasValidDomain = validDomains.some((domain) => value.endsWith(domain));
    return hasValidDomain;
  };
  const emails = isValidEmail(value);
  if (emails) {
    setEmail(value);
    setconfirmemail(value);
  } else {
    setEmail(value);
  }
};
